module.exports = __webpack_public_path__ + "img/12.de906a77.jpg";